
const ContactSection = () => {
  return (
    <div>
      <p className="text-gray-700 leading-relaxed">
        If you have questions about our use of cookies or this Cookie Policy, please contact us:
      </p>
      <div className="bg-gray-50 p-4 rounded-lg">
        <p className="text-gray-700">
          <strong>Email:</strong> privacy@boboteedee.ky<br />
          <strong>Subject Line:</strong> Cookie Policy Inquiry<br />
          <strong>Address:</strong> Bobo & Teedee® Privacy Department<br />
          Grand Cayman, Cayman Islands
        </p>
      </div>
    </div>
  );
};

export default ContactSection;
